import { useTranslation } from "@flare/i18n";
import { cn, Text } from "@flare/ui";

export function PrivacyDisclaimer({ className }: { className?: string }) {
  const { t } = useTranslation();

  return (
    <div className={cn("mb-sp-9 mt-sp-3 md:mb-sp-8", className)}>
      <Text variant="caption" className="text-center">
        {t("FUNNEL_PRIVACY_DISCLAIMER_FIRST_LINE")}
      </Text>
      <Text variant="caption" className="pb-sp-2 text-center md:pb-sp-0">
        {t("FUNNEL_PRIVACY_DISCLAIMER_SECOND_LINE")}
      </Text>
    </div>
  );
}
